export default __webpack_public_path__ + "static/media/ic_arrow_white.81fbc3e0.svg";